import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FALIcon } from 'FAIcon'
import Article from './Article.js'
import update from 'immutability-helper'

class SubArticleClass extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showContent: false
    }
    this.parentsArticle = update(props.parentsArticle, { $push: [props.permalink] })
  }

  showContent = () => {
    if (this.parentsArticle.length > 3) {
      if (this.props.isInternal) {
        window.open('/help/articolo/' + this.props.permalink, '_blank')
      } else {
        this.props.changeView(this.props.permalink, 'articolo')
      }
    } else {
      this.setState(prevState => {
        return { showContent: !prevState.showContent }
      })
    }
  }

  render () {
    return (
      <div className={this.props.className}>
        <div className={this.state.showContent ? 'titleContent' : undefined} onClick={this.showContent} style={{ cursor: 'pointer' }}>
          <FALIcon name={'angle-right'} />
          <span className='title'>{this.props.text}</span>
        </div>
        {this.state.showContent &&
        <Article
          searchKey={this.props.permalink}
          subArticle
          className={'subArticleContent'}
          realm={this.props.realm}
          parentsArticle={this.parentsArticle}
          changeView={this.props.changeView}
          isInternal={this.props.isInternal}
        />
        }
      </div>
    )
  }
}

export const SubArticle = styled(SubArticleClass)`
	border: 1px solid rgba(51,51,51,0.24);
	border-radius: 4px;
	box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);
	margin: 15px 0;
	transition: box-shadow 0.3s ease-in-out;
	padding: 0 20px;
	box-sizing: border-box;
	&:hover{
	  box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);
	}
	span.title{
	  cursor: pointer;
	  display:table-cell;
	  vertical-align: middle;
	  margin-bottom: 0;
	  font-size: 18px;
	  font-weight: 600;
	  padding: 15px 0 15px 15px;
	  width: calc(100% - 15px);
	  box-sizing: border-box;
	}
	.fa,.faicon{
	  font-size: 20px;
	  display: table-cell;
	  vertical-align: middle;
	  transition: transform 400ms ease-out;
	}
	.titleContent{
	  border-bottom:1px solid rgba(51,51,51,0.24);
	  cursor: pointer;
	  .fa,.faicon{
	    transform: rotate(90deg);
	  }
	}
	.articleContent{
    max-width: 100%!important;
    box-sizing: border-box;
	}
	.subArticleContent{
	  margin-top: 10px;
	}
`

SubArticleClass.propTypes = {
  changeView: PropTypes.func,
  parentsArticle: PropTypes.array,
  isInternal: PropTypes.bool
}

SubArticleClass.defaultProps = {
  changeView: undefined,
  parentsArticle: [],
  isInternal: false
}



// WEBPACK FOOTER //
// ./src/help/common/SubArticle.js